import Types from "../../actions/Types";

const UserReducer = (state = [], action) => {
  switch (action.type) {
    case Types.UPSERT_USER:
    case Types.DELETE_USER:
    case Types.GET_USER:
    case Types.CLOSE_ANNOUNCEMENT:
      return [...state, { ...action.payload }];
    default:
      return state;
  }
};

export default UserReducer;
